import { MultiLanguageCollection, ModelTypeDecorator } from '@nts/std';
import { ModuleML } from './module-ml';
import { ModuleMLIdentity } from './module-ml.identity';

@ModelTypeDecorator(ModuleML)
export class ModuleMLCollection extends MultiLanguageCollection<ModuleML, ModuleMLIdentity> {

}
